import { render, staticRenderFns } from "./dialogDetail.vue?vue&type=template&id=463e825e&"
import script from "./dialogDetail.vue?vue&type=script&lang=js&"
export * from "./dialogDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports